const s = "update:modelValue", n = "update:error", e = "change", T = "init", a = "add-child", c = "remove-child", N = "input", _ = "clear", d = "complete", i = "send", V = "blur", D = "focus";
var E = /* @__PURE__ */ ((t) => (t.DragStart = "dragstart", t.Dragmove = "dragmove", t.Dragend = "dragend", t))(E || {}), r = /* @__PURE__ */ ((t) => (t.Resizestart = "resizestart", t.Resizemove = "resizemove", t.Resizeend = "resizeend", t))(r || {}), o = /* @__PURE__ */ ((t) => (t.TransitionStart = "transition-start", t.TransitionEnd = "transition-end", t))(o || {});
const A = "transition-start", R = "transition-end", I = "keydown", O = "close", l = "back";
export {
  a as ADD_CHILD_EVENT,
  l as BACK_EVENT,
  V as BLUR_EVENT,
  e as CHANGE_EVENT,
  _ as CLEAR_EVENT,
  O as CLOSE_EVENT,
  d as COMPLETE_EVENT,
  E as DragEventEnum,
  D as FOCUS_EVENT,
  T as INIT_EVENT,
  N as INPUT_EVENT,
  I as KEYDOWN_EVENT,
  c as REMOVE_CHILD_EVENT,
  r as ResizeEventEnum,
  i as SEND_EVENT,
  R as TRANSITION_END_EVENT,
  A as TRANSITION_START_EVENT,
  o as TransitionEventEnum,
  n as UPDATE_ERROR,
  s as UPDATE_MODEL_VALUE
};
//# sourceMappingURL=events.js.map
